export default __webpack_public_path__ + "static/media/tigerbox_touch_green.c6d6805a.png";